module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_agder_pos.4f58bca2.png";